import React from 'react';
import { Box } from '@mui/material';

const whatGamePcSrc = `${process.env.PUBLIC_URL}/top/TopWhatGame/what_game_pc_hero.webp`;

function TopWhatGamePC() {
  return (
    <Box
      sx={{
        mx: { xs: 1.5, md: 3 },
        mt: 2,
        mb: 2,
        boxSizing: 'border-box',
      }}
    >
      <Box
        component="img"
        src={whatGamePcSrc}
        alt="どんな話題も、予想ゲームになる"
        sx={{
          display: 'block',
          width: '100%',
          maxWidth: 1100,
          mx: 'auto',
          height: 'auto',
        }}
      />
    </Box>
  );
}

export default TopWhatGamePC;
